import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import BeforeAfter from 'vue-before-after-slider' 

import VeeValidate from 'vee-validate'
import ja from 'vee-validate/dist/locale/ja'

VeeValidate.Validator.localize('ja', ja)
VeeValidate.Validator.localize({
  ja: {
    attributes: {
      url: 'チェックするページのURL',
      email: '通知先メールアドレス',
    }
  }
})

Vue.use(VeeValidate, { locale: ja })

Vue.config.productionTip = false

import Header from '@/components/Header'
Vue.component('my-header', Header)

import Lib from '@/lib'
import i18n from './i18n'
Vue.filter('i18nSimulation', (value) => Lib.preset().i18n.simulations[value] || value);
Vue.filter('i18nFormat', (value) => Lib.preset().i18n.types[value] || value);

Vue.use(BeforeAfter)

router.afterEach(to => {
  if (window && window.mt) {
    const values = {}
    const email = window.localStorage.getItem('email')
    if (email) values.email = email
    mt('send', 'pageview', values)
  }
})

new Vue({
  data: () => {
    return {
    }
  },

  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
